import { render, staticRenderFns } from "./TriggerVariablesCard.vue?vue&type=template&id=d0ca96f0&scoped=true"
import script from "./TriggerVariablesCard.vue?vue&type=script&lang=ts"
export * from "./TriggerVariablesCard.vue?vue&type=script&lang=ts"
import style0 from "./TriggerVariablesCard.vue?vue&type=style&index=0&id=d0ca96f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0ca96f0",
  null
  
)

export default component.exports